import { Component, EventEmitter, Input, Output } from '@angular/core';

// Shared range slider + number input. The range is bound one-way ([value]) with (input) so the
// native control can't clamp the value to its default max before [max] applies.
@Component({
  selector: 'omp-slider',
  templateUrl: './omp-slider.component.html',
  styleUrls: ['./omp-controls.scss'],
})
export class OmpSliderComponent {
  @Input() value: number;
  @Input() unit = '';
  @Input() min = 0;
  @Input() max = 100;
  @Output() valueChange = new EventEmitter<number>();

  emit(value: number) {
    this.valueChange.emit(value);
  }

  rangeBackground(value: number, min: number, max: number) {
    let percent = 0;
    if (max > min) {
      percent = ((value - min) / (max - min)) * 100;
    }
    if (percent < 0) {
      percent = 0;
    }
    if (percent > 100) {
      percent = 100;
    }
    return `linear-gradient(to right, #2eb3c9 0%, #2eb3c9 ${percent}%, #ccc ${percent}%, #ccc 100%)`;
  }
}
